import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import NewCommonServiceContent from "../../../common/NewCommonServices/NewCommonServiceContent";

const YooutubeVideoWork = () => {
  return (
    <div>
      <NewCommonServiceContent>
        <div>
          <Swiper
            modules={[Navigation, Pagination, Autoplay]}
            className="flex justify-center items-center"
            pagination={{
              type: "bullets",
              el: ".pagination-progress",
              clickable: true,
            }}
            breakpoints={{
              1024: {
                slidesPerView: 4,
              },
            }}
            spaceBetween={20}
            navigation={{
              nextEl: ".swiper-button-next",
              prevEl: ".swiper-button-prev",
            }}
            loop
          >
            <SwiperSlide>
              <iframe
                height="500"
                src="https://www.youtube.com/embed/EoCLB5_pXqw"
                title="YouTube video player1"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
                className="no-scrollbar rounded-[16px]"
              ></iframe>
            </SwiperSlide>
            <SwiperSlide>
              <iframe
                height="500"
                src="https://www.youtube.com/embed/jCa-sGRyOW4"
                title="YouTube video player2"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
                className="no-scrollbar rounded-[16px]"
              ></iframe>
            </SwiperSlide>
            <SwiperSlide>
              <iframe
                height="500"
                src="https://www.youtube.com/embed/xLOhN9pcLlU"
                title="YouTube video player3"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
                className="no-scrollbar rounded-[16px]"
              ></iframe>
            </SwiperSlide>
            <SwiperSlide>
              <iframe
                height="500"
                src="https://www.youtube.com/embed/D6szxHMJZhA"
                title="YouTube video player4"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
                className="no-scrollbar rounded-[16px]"
              ></iframe>
            </SwiperSlide>
            <SwiperSlide>
              <iframe
                height="500"
                src="https://www.youtube.com/embed/Eo453hAve-g"
                title="YouTube video player5"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
                className="no-scrollbar rounded-[16px]"
              ></iframe>
            </SwiperSlide>
            <SwiperSlide>
              <iframe
                height="500"
                src="https://www.youtube.com/embed/GAEtKKtCMO0"
                title="YouTube video player6"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
                className="no-scrollbar rounded-[16px]"
              ></iframe>
            </SwiperSlide>
            <SwiperSlide>
              <iframe
                height="500"
                src="https://www.youtube.com/embed/SP9Zj2rIJ0I"
                title="YouTube video player7"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
                className="no-scrollbar rounded-[16px]"
              ></iframe>
            </SwiperSlide>
            <SwiperSlide>
              <iframe
                height="500"
                src="https://www.youtube.com/embed/IcdrN5ncn8Q"
                title="YouTube video player8"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
                className="no-scrollbar rounded-[16px]"
              ></iframe>
            </SwiperSlide>
          </Swiper>
          <div className="swiper-pagination pagination-progress w-full py-5"></div>
        </div>
      </NewCommonServiceContent>
    </div>
  );
};

export default YooutubeVideoWork;
